/* eslint-disable react/require-render-return */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Error)]),
    validate: PropTypes.any // eslint-disable-line react/forbid-prop-types
}

/**
 * This is the base class that all components that implement a form field must
 * inherit from (like TextField, DatePicker, ...). The <Form> will recognize
 * which of its children are form fields by testing if they are a component
 * that inherits from this base class.
 *
 * @deprecated: Please don't use it anymore! Using base classes is the root
 * of all eval in a react world :-)
 *
 * Don't forget to render `this.props.error` if present:
 * @example <ErrorPopover formField={this} error={this.props.error} />
 */
class FormField extends Component {
    /**
     * Provide some useful render method instead of this. This is just a friendly reminder.
     */
    render() {
        throw new Error('Extend this class when writing your form field component. FormField on itself is useless.')
    }

    /**
     * Override this method with your own implementation.
     */
    getValue() {
        throw new Error('getValue() is not implemented')
    }

    /**
     * Override this method with your own validation implementation.
     * Return error or false if validation fails. Return true on success.
     *
     * @return {bool|Error}
     */
    validate() {
        if (!this.props.validate) {
            return new Error('validate() is not implemented.')
        }

        const validation = this.props.validate(this.getValue())
        return validation || new Error('Invalid form field value.')
    }
}

FormField.propTypes = propTypes

export default FormField
